import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import {NotificationService} from './notification.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class EncrDecrService {

  private masterKey = 'High!234Tid3';

  constructor( private notify: NotificationService,
               private router: Router) {

  }

  // encrypt the value
  encrypt(value) {
    const key = CryptoJS.enc.Utf8.parse(this.masterKey);
    const iv = CryptoJS.enc.Utf8.parse(this.masterKey);
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
      {
        keySize: 128 / 8,
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

    return encrypted.toString();
  }

  // decrypt the value.
  decrypt(value) {
    if (!value || value === null || value?.length === 0)
    {
      this.notify.warning('An expected encrypted value is not present. Auto logout executed.');
      this.router.navigate(['/login']).then();
      return '';
    }
    const key = CryptoJS.enc.Utf8.parse(this.masterKey);
    const iv = CryptoJS.enc.Utf8.parse(this.masterKey);
    const decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}
